import { useState, useEffect } from 'react';

const PROMO_SHOWN_KEY = 'promo_shown_today';

export const usePromoModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const today = new Date().toDateString();
    const lastShown = localStorage.getItem(PROMO_SHOWN_KEY);

    if (lastShown !== today) {
      const timer = setTimeout(() => {
        setIsOpen(true);
        localStorage.setItem(PROMO_SHOWN_KEY, today);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, []);

  const closeModal = () => setIsOpen(false);

  return { isOpen, closeModal };
};
